import { defaultRangePreset, rangePresets } from '@gogame/intl-ts';
import { array, object, string } from '@gogame/schemas';

import { FILTER_ACTIONS, FILTER_ACTIONS_BY, FILTER_PERIOD } from './constants';

export const actionsLogSchema = object({
  [FILTER_ACTIONS]: string(),
  [FILTER_ACTIONS_BY]: string(),
  [FILTER_PERIOD]: array(string())
    .default(rangePresets.LIFETIME.value)
    .constants(defaultRangePreset),
});
